const IMAGE_EXTENSIONS = /\.(png|jpe?g|webp|gif|avif)(?:\?.*)?$/i;

export function isImageArtifact(value) {
  return IMAGE_EXTENSIONS.test(String(value || ""));
}

export function isExternalArtifact(value, origin = globalThis.location?.origin || "http://worldloom.local") {
  try {
    const url = new URL(String(value || ""), origin);
    return /^https?:$/.test(url.protocol) && url.origin !== origin;
  } catch {
    return false;
  }
}

export function artifactUrl(value, fileUrl = (key) => `/files/${key}`) {
  const uri = String(value || "");
  if (isExternalArtifact(uri) || uri.startsWith("/files/")) return uri;
  return fileUrl(uri);
}

export function artifactLink({ uri, label, esc, fileUrl }) {
  const href = artifactUrl(uri, fileUrl);
  const text = label || fileName(uri);
  if (isExternalArtifact(uri)) {
    return `<a class="artifact-link" href="${esc(href)}" target="_blank" rel="noopener noreferrer">${esc(text)} <b>External ↗</b></a>`;
  }
  if (isImageArtifact(uri)) {
    return `<button type="button" class="artifact-link" data-artifact-lightbox-src="${esc(href)}" data-artifact-lightbox-label="${esc(text)}">${esc(text)} <b>Enlarge image</b></button>`;
  }
  return `<a class="artifact-link" href="${esc(href)}" download>${esc(text)} <b>Download</b></a>`;
}

export function imagePreview({ uri, label, alt, esc, fileUrl, className = "" }) {
  const href = artifactUrl(uri, fileUrl);
  if (isExternalArtifact(uri)) {
    return `<a href="${esc(href)}" target="_blank" rel="noopener noreferrer">${esc(label || "Reference image")} <b>External ↗</b></a>`;
  }
  return `<button type="button" data-artifact-lightbox-src="${esc(href)}" data-artifact-lightbox-label="${esc(label || alt || "Reference image")}"><img class="${esc(className)}" src="${esc(href)}" alt="${esc(alt || label || "Reference image")}" loading="lazy" /></button>`;
}

export function bindArtifactLightboxes(root) {
  root.querySelectorAll("[data-artifact-lightbox-src]").forEach((button) => {
    button.addEventListener("click", () => openArtifactLightbox({
      src: button.dataset.artifactLightboxSrc,
      label: button.dataset.artifactLightboxLabel,
      returnFocus: button,
    }));
  });
}

export function openArtifactLightbox({ src, label = "Image preview", returnFocus = document.activeElement }) {
  document.querySelector(".artifact-lightbox-dialog")?.close();
  document.querySelector(".artifact-lightbox-dialog")?.remove();
  const dialog = document.createElement("dialog");
  dialog.className = "artifact-lightbox-dialog";
  dialog.setAttribute("aria-label", label);
  const closeButton = document.createElement("button");
  closeButton.type = "button";
  closeButton.className = "artifact-lightbox-close";
  closeButton.setAttribute("aria-label", "Close image preview");
  closeButton.textContent = "×";
  const figure = document.createElement("figure");
  const image = document.createElement("img");
  image.src = src;
  image.alt = label;
  const caption = document.createElement("figcaption");
  caption.textContent = label;
  figure.append(image, caption);
  dialog.append(closeButton, figure);
  const close = () => {
    dialog.close();
    dialog.remove();
    returnFocus?.focus?.();
  };
  closeButton.addEventListener("click", close);
  dialog.addEventListener("click", (event) => { if (event.target === dialog) close(); });
  dialog.addEventListener("cancel", (event) => { event.preventDefault(); close(); });
  document.body.appendChild(dialog);
  dialog.showModal();
  closeButton.focus();
}

function fileName(value) {
  return String(value || "artifact").split("/").pop() || "artifact";
}
